/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logo_AltInputs */

const en_auth_logo_alt = /** @type {(inputs: Auth_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening Logo`)
};

const es_auth_logo_alt = /** @type {(inputs: Auth_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de Listening`)
};

/**
* | output |
* | --- |
* | "Listening Logo" |
*
* @param {Auth_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_logo_alt = /** @type {((inputs?: Auth_Logo_AltInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logo_AltInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_logo_alt(inputs)
	return en_auth_logo_alt(inputs)
});